import React from 'react'

export const WebViewPrimitive = ({ uri, javaScriptEnabled }) => {
    return <iframe
        height={"100%"}
        src={uri}
        style={{ border: "none" }}
    />
}